import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { singletonGetter } from "../../singletons/getter";
export var PageLoadTracker = function PageLoadTracker() {
    "use strict";
    var _this = this;
    _class_call_check(this, PageLoadTracker);
    this.pagesLoaded = new Map();
    this.wasPageLoaded = function(pageName) {
        var _this_pagesLoaded_get;
        return (_this_pagesLoaded_get = _this.pagesLoaded.get(pageName)) !== null && _this_pagesLoaded_get !== void 0 ? _this_pagesLoaded_get : false;
    };
    this.setPageLoaded = function(pageName) {
        _this.pagesLoaded.set(pageName, true);
    };
};
PageLoadTracker.get = singletonGetter(PageLoadTracker);
